// Copyright: Sean O'Donoghue

import {ref} from "vue";

// Single shared ref so that every ProgramTable on a page (in-person and
// virtual sessions) follows the same timezone selection.
const timeZoneSelected = ref(null);

export default function useTimeZoneSelected() {
  return timeZoneSelected;
}
